// ABOUTME: Hook for triggering celebration animations (confetti + toast)
// ABOUTME: Respects prefers-reduced-motion accessibility setting

import { useCallback } from 'react';
import confetti from 'canvas-confetti';
import { confettiColors, confettiFireColors } from '../theme/tokens';

interface CelebrationOptions {
  message: string;
  onToast?: (message: string) => void;
}

export const useCelebration = () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const celebrate = useCallback(({ message, onToast }: CelebrationOptions) => {
    // Always show toast
    if (onToast) {
      onToast(message);
    }

    // Skip confetti if user prefers reduced motion
    if (prefersReducedMotion) {
      return;
    }

    // Fire confetti
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: [...confettiColors]
    });
  }, [prefersReducedMotion]);

  // Fire animation for destructive actions like nuclear reset (Issue #1310)
  // Bursts of fire-colored particles rising from the bottom
  const badCelebration = useCallback(() => {
    if (prefersReducedMotion) {
      return;
    }

    const fireColors = [...confettiFireColors];

    // Center burst rising upward
    confetti({
      particleCount: 80,
      spread: 60,
      origin: { x: 0.5, y: 1 },
      colors: fireColors,
      gravity: -0.8,
      ticks: 300,
    });
    // Left burst
    confetti({
      particleCount: 50,
      spread: 45,
      origin: { x: 0.15, y: 1 },
      colors: fireColors,
      gravity: -0.8,
      drift: 0.4,
      ticks: 300,
    });
    // Right burst
    confetti({
      particleCount: 50,
      spread: 45,
      origin: { x: 0.85, y: 1 },
      colors: fireColors,
      gravity: -0.8,
      drift: -0.4,
      ticks: 300,
    });
  }, [prefersReducedMotion]);

  return { celebrate, badCelebration };
};
